/** Rótulos amigáveis dos módulos gravados em `auditoria_eventos` (campo `modulo`, texto livre no backend). */
const ROTULOS_MODULO: Record<string, string> = {
  empresa: 'Empresa',
  usuario: 'Usuários',
  departamento: 'Departamentos',
  cargo: 'Cargos',
  okrs: 'OKRs',
  projetos: 'Projetos',
  cronogramas: 'Cronogramas',
  organograma: 'Organogramas',
  fluxogramas: 'Fluxogramas',
  formularios: 'Formulários',
  calendario: 'Calendário',
  treinamentos: 'Treinamentos',
  notificacoes: 'Notificações',
};

/** Lê só chave PRÓPRIA do mapa: num objeto comum, `mapa['constructor']` devolveria a função do protótipo. */
const doMapa = (mapa: Record<string, string>, chave: string): string | undefined =>
  Object.prototype.hasOwnProperty.call(mapa, chave) ? mapa[chave] : undefined;

/** Rótulo do módulo; módulo novo no backend (sem rótulo aqui) aparece como veio, sem quebrar a tela. */
export const rotuloModuloAuditoria = (modulo: string): string => doMapa(ROTULOS_MODULO, modulo) ?? modulo;

/** Rótulos dos campos do de/para. Os `*_id` guardam o id de outro registro — o backend manda `id → nome` em `nomes`. */
const ROTULOS_CAMPO: Record<string, string> = {
  lider_id: 'Líder',
  tipo_id: 'Tipo',
  departamento_id: 'Departamento',
  cargo_id: 'Cargo',
  gestor_usuario_id: 'Gestor',
  empresa_id: 'Empresa',
  calendario_id: 'Calendário',
  categoria_id: 'Categoria',
  quantidade_quadro: 'Quantidade no quadro',
};

export const rotuloCampoAuditoria = (campo: string): string => doMapa(ROTULOS_CAMPO, campo) ?? campo;

/**
 * Texto de um valor do de/para. `String()` direto vira "[object Object]" para lista de objetos
 * (investimentos do projeto) e objeto JSON (configuração de pergunta de formulário); id de outro
 * registro vira o nome quando o backend o resolveu (`nomes`).
 */
export const formatarValorAuditoria = (valor: unknown, nomes: Record<string, string> = {}): string => {
  if (valor === null || valor === undefined || valor === '') return '—';
  if (typeof valor === 'string') return doMapa(nomes, valor) ?? valor;
  if (typeof valor === 'object') {
    if (Array.isArray(valor)) {
      if (valor.length === 0) return '(vazio)';
      return valor.map((item) => (typeof item === 'object' && item !== null ? JSON.stringify(item) : String(item))).join('; ');
    }
    return JSON.stringify(valor);
  }
  return String(valor);
};
